import { SERIES } from "../constants/constants";

export class AttendancePayload {
  providerSK: string;
  editMode: number;
  editScope: string;
  startDate: string;
  startTime: string;
  endTime: string;
  providerMeetingSk: string | null;
  isAdd: boolean;
  isSession: boolean;
  recurringMeetingSk: string | null;
  recurrenceType: string | null;
  interval: number;
  occurrenceCount: number | null;
  endByDate: string | null;
  daysOfWeek: string | null;
  monthlyPattern: string | null;
  monthlyWeekOfMonth: string | null;
  monthlyWeekday: string | null;
  monthlyDayOfMonth: number | null;
  isEditingSession: boolean | null;
  canceledDate: string | null;

  constructor(
    providerSK: string,
    data
  ) {
    this.providerSK = providerSK;
    this.editMode = 0;
    this.editScope = SERIES;
    this.startDate = data?.date;
    this.startTime = data?.startTime;
    this.endTime = data?.endTime;
    this.providerMeetingSk = null;
    this.isAdd = true;
    this.isSession = false;
    this.recurringMeetingSk = null;
    this.recurrenceType = null;
    this.interval = 1;
    this.occurrenceCount = null;
    this.endByDate = null;
    this.daysOfWeek = null;
    this.monthlyPattern = null;
    this.monthlyWeekOfMonth = null;
    this.monthlyWeekday = null;
    this.monthlyDayOfMonth = null;
    this.isEditingSession = null;
    this.canceledDate = null;
  }
}